import { Avatar, Box, Card, Icon, ResourceItem, ResourceList, Text, TextField, useBreakpoints } from '@shopify/polaris';
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { CheckIcon, SearchIcon } from '@shopify/polaris-icons';
import helpers from 'helpers/index';
import { TypedSeating, useMutateGetSeatings } from 'queries/seating.query';

type TypedQuickSearchSeating = {
  current_seating_id?: any;
  onClose?: (val: TypedSeating) => void;
  title: string;
  placeholder?: string;
  disabled?: boolean;
};

/**
 *
 * @param current_user_id bigint
 * @param  onClose callback with bigint userid
 * @returns
 */
export default function QuickSearchSeating({
  current_seating_id = null,
  disabled,
  onClose,
  title = 'Tìm một loại hình vận chuyển',
  placeholder = 'Tìm một loại hình vận chuyển',
}: TypedQuickSearchSeating) {
  const { mutateAsync: searchSeating, isSuccess } = useMutateGetSeatings();

  const initialQuery = {
    query: '',
    sort: 'createdAt:desc',
    seating_status: 1,
    limit: 10,
  };

  const [mainQuery, setMainQuery] = useState(initialQuery);

  /**
   * User list
   */
  const [seatingList, setSeatingList] = useState<any[]>([]);

  const onQueryToServer = useCallback(async (queryString) => {
    try {
      let data = await searchSeating(queryString);
      // @ts-ignore
      setSeatingList(data);
    } catch (e) {}
  }, []);

  useEffect(() => {
    if (mainQuery) {
      onQueryToServer(mainQuery);
    }
  }, [mainQuery]);

  /**
   * Assign cho ai đóa
   */
  const [userQuickSearchText, setUserQuickSearchText] = useState<string>('');

  const onQueryToServerDebound = useCallback((keyword) => {
    setMainQuery((old) => ({ ...old, ...{ query: keyword } }));
  }, []);

  const onChangeMainQueryCallback = useMemo(() => {
    return helpers.debounce((_value: string) => {
      onQueryToServerDebound?.call(this, _value);
    }, 400);
  }, []);

  const updateUserText = useCallback((value: string) => {
    setUserQuickSearchText(value);
    onChangeMainQueryCallback(value);
  }, []);

  const updateSelection = useCallback(
    (id: string) => {
      const matchedOption = seatingList.find((option) => {
        return option.id === id;
      });
      setUserQuickSearchText(matchedOption.display_name || '');
      // @ts-ignore
      onClose?.call(this, matchedOption);
    },
    [seatingList]
  );

  const { smUp } = useBreakpoints();
  return (
    <Box minWidth="250px" maxWidth={smUp ? `300px` : '100%'} padding={{ xs: '0', sm: '0', md: '200' }}>
      <Card>
        <TextField
          readOnly={disabled}
          onChange={updateUserText}
          label={title}
          disabled={disabled}
          value={userQuickSearchText}
          prefix={<Icon source={SearchIcon} tone="base" />}
          placeholder={placeholder}
          autoComplete="off"
          clearButton
          onClearButtonClick={() => updateUserText('')}
        />
      </Card>
      <ResourceList
        emptyState={
          isSuccess && helpers.isEmpty(seatingList) ? (
            <Box padding={'400'}>
              <Text as="p" tone="subdued">
                Chưa thấy loại hình nào được cài đặt!
              </Text>
            </Box>
          ) : null
        }
        resourceName={{ singular: 'driver', plural: 'driver' }}
        items={seatingList || []}
        renderItem={(item: TypedSeating) => {
          const { id, seating_name, seating_description } = item;

          return (
            <ResourceItem
              verticalAlignment="center"
              id={id}
              onClick={() => updateSelection(id)}
              media={current_seating_id === id ? <Icon source={CheckIcon} /> : null}
            >
              <Text variant="bodyMd" fontWeight="bold" as="p">
                {seating_name}
              </Text>
              {seating_description ? (
                <Text variant="bodyMd" tone="subdued" as="p">
                  {seating_description}
                </Text>
              ) : null}
            </ResourceItem>
          );
        }}
      />
    </Box>
  );
}

